import styled, { css } from "styled-components";
import asqioAuthLogo from "../../assets/asqio_logo_auth.webp";
import asqioNavbarLogo from "../../assets/asqio_logo_nav.webp";
import { designSystemVars as vars } from "../tokens";

type BrandLogoPlacement = "auth" | "navbar";

interface BrandLogoProps {
  placement: BrandLogoPlacement;
}

const authBrandLetters = Array.from("Asqio");

const BrandLockup = styled.div<{ $placement: BrandLogoPlacement }>`
  display: flex;
  align-items: center;
  color: ${vars.color.text.primary};
  font-family: ${vars.typography.family.sans};
  font-weight: ${vars.typography.weight.bold};

  ${({ $placement }) =>
    $placement === "auth"
      ? css`
          width: min(600px, calc(100% - 64px));
          flex-direction: column;
          gap: ${vars.spacing.xs};
        `
      : css`
          flex-direction: row;
          gap: ${vars.spacing.xs};
        `}
`;

const BrandImage = styled.img<{ $placement: BrandLogoPlacement }>`
  display: block;
  flex: none;
  object-fit: contain;

  ${({ $placement }) =>
    $placement === "auth"
      ? css`
          width: 100%;
          height: auto;
          max-height: calc(100vh - 184px);
        `
      : css`
          width: 50px;
          height: 50px;
        `}
`;

const BrandName = styled.span<{ $placement: BrandLogoPlacement }>`
  display: block;
  margin: 0;
  white-space: nowrap;

  ${({ $placement }) =>
    $placement === "auth"
      ? css`
          display: flex;
          justify-content: space-between;
          width: 100%;
          font-size: clamp(
            var(--inzeloop-ds-font-size-64px),
            var(--inzeloop-ds-font-size-8vw),
            var(--inzeloop-ds-font-size-112px)
          );
          line-height: var(--inzeloop-ds-line-height-tight);
        `
      : css`
          font-size: ${vars.typography.size.lg};
          line-height: ${vars.typography.lineHeight.lg};
        `}
`;

export const BrandLogo: React.FC<BrandLogoProps> = ({ placement }) => (
  <BrandLockup $placement={placement}>
    <BrandImage
      src={placement === "auth" ? asqioAuthLogo : asqioNavbarLogo}
      alt="Asqio logo"
      $placement={placement}
    />
    <BrandName $placement={placement} aria-hidden="true">
      {placement === "auth"
        ? authBrandLetters.map((letter, index) => (
            <span key={`${letter}-${index}`}>{letter}</span>
          ))
        : "Asqio"}
    </BrandName>
  </BrandLockup>
);
